/**
     * DO NOT USE - moved to interfaces for better import location
     * @deprecated as of version 12.15.0
     */
export * from '../../interfaces/WebTemplateType';
export { default as default } from '../../interfaces/WebTemplateType';